<script lang="ts" setup>
const props = defineProps<{
  slidesCount: number | undefined | null,
  currentSlide: number,
}>();
const swiper = useSwiper();

function setCurrentSlide(num: number) {
  if (num != props.currentSlide) {
    swiper.value.slideTo(num);
  }
}
</script>

<template>
  <div class="slider-pagination">
    <div
      class="slider-pagination__dot"
      v-for="num in slidesCount"
      :class="(num - 1) == currentSlide && 'active'"
      :key="num + '__slider-dot'"
      @click="setCurrentSlide(num - 1)"
    />
  </div>
</template>

<style lang="scss" scoped>
.slider {
  &-pagination {
    width: max-content;
    position: absolute;
    z-index: 1;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 4px;
    &__dot {
      cursor: pointer;
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: $control-bg_grey;
      transition: {
        property: width, background-color;
        duration: 0.3s;
      };
      &.active {
        width: 12px;
        border-radius: 6px;
        background-color: $bg_black;
      }
    }
  }
}

</style>
